import * as angular from 'angular';
import {IController} from "angular";

export class DeliveryDetailedViewPricingCtrl implements IController {
  delivery: any;
  billing: any;

}

angular
  .module('bringoz.admin.deliveries')
  .component('deliveryDetailedViewPricing', {
    bindings: {
      delivery: '<',
      billing: '<'
    },
    template: require('./delivery-detailed-view-pricing.html').default,
    controller: DeliveryDetailedViewPricingCtrl
  });
